import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import "./flashmessage.style.css";

function FlashMessageView({ message, type = "success", onClose }) {
    const { t } = useTranslation();

    return (
        <div
            className={`flash-message flash-${type}`}
            role={type === 'error' ? 'alert' : 'status'}
            aria-live={type === 'error' ? 'assertive' : 'polite'}
            aria-atomic="true"
        >
            <span className="flash-message-text">{message}</span>
            <button
                type="button"
                className="flash-close btn-close"
                onClick={onClose}
                aria-label={t('common.close')}
            >
                ×
            </button>
        </div>
    );
}

FlashMessageView.propTypes = {
    message: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['success', 'error', 'warning', 'info']),
    onClose: PropTypes.func.isRequired,
};

export default FlashMessageView;
